import {
  DEFAULT_TITLE,
  useCustomRouteNames,
  useExactMatchedRoute,
} from './routeHookHelpers';

export default () => {
  const matchedRoute = useExactMatchedRoute();
  const customNames = useCustomRouteNames();
  return matchedRoute ? matchedRoute.title(customNames) : DEFAULT_TITLE;
};
